export default __webpack_public_path__ + "static/media/member-fallback.1550999c.svg";